// ---------------------------------------------- modules import
import moment from "moment";
import React, { FunctionComponent } from "react";

import { ISummaryProps } from "./common";

// ---------------------------------------------- the component
const Summary: FunctionComponent<ISummaryProps> = ({ post }) => {
  const { title, category, author, lastModified } = post;

  // ---------------------------------------------- content
  return (
    <div className="card col s12 m5 offset-m1">
      <div
        className="card-content grey-text text-darken-3"
        style={{ padding: "16px" }}
      >
        <span
          className={`new badge ${
            category === "human resource"
              ? "indigo accent-2"
              : category === "operational"
              ? "green accent-3"
              : category === "administration"
              ? "orange accent-2"
              : category === "report"
              ? "red accent-2"
              : "purple accent-2"
          }`}
          data-badge-caption={category}
        />

        <span
          style={{
            fontSize: "0.8rem",
            display: "block",
            margin: "8px 0px 2px"
          }}
        >
          {moment(lastModified.toDate()).calendar()}
        </span>

        <span className="truncate" style={{ fontSize: "1.2rem" }}>
          {title}
        </span>

        <p style={{ fontSize: "0.8rem" }}>posted by {author.name}</p>
      </div>
    </div>
  );
};

export default Summary;
